import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  CuttingMatBaseGroup,
  CuttingMeasure,
  CuttingOperation,
  ICustomResponse,
  ICuttingBaseMaterial,
  TypeGroupMaterial,
  customResponse
} from 'cloud-shared-lib';
import { Observable, of } from 'rxjs';
import { ApiLinks } from '../modules/cutting-panel-list/csl.api-links';

export interface CuttingOperationResponse {
  operationsDTO: CuttingOperation[];
  operationsCount: number;
}

@Injectable({
  providedIn: 'root',
})
export class MaterialBaseService {
  constructor(private http: HttpClient, ) {}

  getMatBaseMaterials(
    groupId: number,
    pageSize: number,
    pageIndex: number,
    filterText: string
  ): Observable<ICustomResponse<{ materialsDTO: ICuttingBaseMaterial[]; materialsCount: number }>> {
    if (+groupId <= 0 && +pageIndex < 0 && +pageSize <= 0) {
      return of({ result: { materialsDTO: [], materialsCount: 0 }, error: null });
    }

    const searchParams: HttpParams = new HttpParams()
      .set('groupId', groupId.toString())
      .set('pageSize', pageSize.toString())
      .set('pageIndex', pageIndex.toString())
      .set('filterText', filterText);

    return this.http
      .get(ApiLinks.materialBase + '/material-list', { params: searchParams })
      .pipe(customResponse<{ materialsDTO: ICuttingBaseMaterial[]; materialsCount: number }>());
  }

  public getMatBaseMaterialGroups = (groupTypes?: TypeGroupMaterial[]): Observable<CuttingMatBaseGroup[]> => {
    let paramsHttp: HttpParams = new HttpParams();

    if (groupTypes) {
      groupTypes.forEach(g => {
        paramsHttp = paramsHttp.append('groupType', g.toString());
      });
    }

    return this.http.get<CuttingMatBaseGroup[]>(ApiLinks.materialGroup, { params: paramsHttp });
  };

  getMatBaseOperationGroups(): Observable<ICustomResponse<CuttingMatBaseGroup[]>> {
    return this.http.get(ApiLinks.operationGroups).pipe(customResponse<CuttingMatBaseGroup[]>());
  }

  getMatBaseOperations(
    groupId: number,
    pageIndex: number,
    pageSize: number,
    search: string
  ): Observable<ICustomResponse<CuttingOperationResponse>> {
    const paramsHttp: HttpParams = new HttpParams()
      .set('pageIndex', pageIndex.toString())
      .set('pageSize', pageSize.toString())
      .set('groupId', groupId.toString())
      .set('search', search);

    return this.http
      .get(ApiLinks.operationList, { params: paramsHttp })
      .pipe(customResponse<CuttingOperationResponse>());
  }

  getMeasures(): Observable<CuttingMeasure[]> {
    return this.http.get<CuttingMeasure[]>(ApiLinks.measures);
  }
}
